'use strict';
import template from './cambioDomicilioPCD.html';
import controller from './cambioDomicilioPCD.controller';

const cambioDomicilioPCDComponent = {
  controller,
  template
};

export default cambioDomicilioPCDComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/cambioDomicilioPCD/cambioDomicilioPCD.component.js